module.exports = __webpack_public_path__ + "img/添加.3eb79315.png";